import { useEffect, useState } from "react";
import RadioButton from "../RadioButton/RadioButton";
import CheckBox from "../Checkbox/CheckBox";

interface Props {
  questionType: string;
  isCheckedInitialValue: boolean;
  value: string;
  setSelectedSubOptions: (value: string[]) => void;
  selectedSubOptions: string[] | undefined;
  isLast: boolean;
  subOptionOthersValue: string;
  setSubOptionOthersValue: (value: string) => void;
  setIsEdited: React.Dispatch<React.SetStateAction<boolean>>;
  setEnabledSectionsCount: React.Dispatch<React.SetStateAction<number>>;
  accordionId: number;
}

const SubOption: React.FC<Props> = ({
  questionType,
  isCheckedInitialValue,
  value,
  setSelectedSubOptions,
  selectedSubOptions,
  isLast,
  subOptionOthersValue,
  setSubOptionOthersValue,
  setIsEdited,
  setEnabledSectionsCount,
  accordionId
}) => {
  const [subOptionOthersInputError, setSubOptionOthersInputError] =
    useState<string>("");

  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (selectedSubOptions?.[0] === "Others" && value === "Others") {
      if (subOptionOthersValue) {
        setSubOptionOthersInputError("");
      } else {
        setSubOptionOthersInputError("Please enter at least 1 character");
        setEnabledSectionsCount(accordionId + 1);
      }
    }
  }, [JSON.stringify(selectedSubOptions), value, subOptionOthersValue]);

  return (
    <div className="mb-6">
      <button
        className="flex flex-row w-full items-center justify-between mb-6"
        onClick={e => {
          e.preventDefault();
          setIsEdited(true);
          if (questionType === "single-option") {
            setSelectedSubOptions([value]);
          } else if (questionType === "multiple-option") {
            if (selectedSubOptions?.includes(value)) {
              setSelectedSubOptions(
                selectedSubOptions?.filter(subOption => subOption !== value)
              );
            } else {
              setSelectedSubOptions([...(selectedSubOptions || []), value]);
            }
          }
        }}
      >
        <label className="text-gray-600 pointer-events-none">{value}</label>
        {questionType === "single-option" ? (
          <RadioButton isActive={value === selectedSubOptions?.[0]} />
        ) : (
          <CheckBox
            isActive={
              questionType === "multiple-option"
                ? selectedSubOptions?.includes(value)
                : false
            }
          />
        )}
      </button>
      {selectedSubOptions?.[0] === "Others" && value === "Others" ? (
        <div>
          <input
            className={`w-full py-3 px-[10px] h-12 rounded-xl border ${
              subOptionOthersInputError
                ? "border-status-negative"
                : "border-grey-light"
            } focus:outline-none`}
            value={subOptionOthersValue}
            onKeyDown={handleKeyDown}
            onChange={e => {
              setIsEdited(true);
              setSubOptionOthersValue(e.target.value?.trimStart());
            }}
          />
          {subOptionOthersInputError ? (
            <p className="text-12-r mt-1 text-status-negative">
              {subOptionOthersInputError}
            </p>
          ) : null}
        </div>
      ) : null}
      {!isLast && <div className="bg-grey-light-border h-[1px]" />}
    </div>
  );
};

export default SubOption;
